/**
 * Login page component - Terminal aesthetic
 */

import { useState, FormEvent } from 'react';
import { useAuth } from '../hooks/useAuth';
import './LoginPage.css';

interface LoginPageProps {
  onSwitchToRegister: () => void;
}

export function LoginPage({ onSwitchToRegister }: LoginPageProps) {
  const { login, error, clearError, isLoading } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLocalError('');
    clearError();

    // Validation
    if (!username.trim()) {
      setLocalError('Username is required');
      return;
    }
    if (!password) {
      setLocalError('Password is required');
      return;
    }

    try {
      await login({ username: username.trim(), password });
      // On success, AuthContext will update and App.tsx will show main UI
    } catch (err) {
      // Error is set in AuthContext
      console.error('Login failed:', err);
    }
  };

  const displayError = localError || error;

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>&gt; SIMULATION GATEWAY</h1>
          <p>AUTHENTICATION REQUIRED</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">USERNAME:</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="ENTER USERNAME"
              disabled={isLoading}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">PASSWORD:</label>
            <div className="password-input-group">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="ENTER PASSWORD"
                disabled={isLoading}
              />
              <button
                type="button"
                className="toggle-password-btn"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'HIDE' : 'SHOW'}
              </button>
            </div>
          </div>

          {displayError && (
            <div className="error-message" role="alert">
              ERROR: {displayError}
            </div>
          )}

          <button
            type="submit"
            className="login-btn"
            disabled={isLoading}
          >
            {isLoading ? 'AUTHENTICATING...' : 'LOGIN'}
          </button>

          <div className="login-footer">
            <p>
              NO ACCOUNT?{' '}
              <button
                type="button"
                className="link-btn"
                onClick={onSwitchToRegister}
                disabled={isLoading}
              >
                REGISTER
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
